/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { NgModule } from '@angular/core';
import { GmcErrorDirective } from './gmc-error.directive';
import { GmcErrorsComponent } from './gmc-errors.component';

@NgModule({
  imports: [GmcErrorsComponent, GmcErrorDirective],
  exports: [GmcErrorsComponent, GmcErrorDirective],
})
export class GmcErrorsModule {}
